export function calculaTabFinal(tabela_Liq: number, val_ipi_calc: number) {
  return tabela_Liq + val_ipi_calc;
}
